import {Outlet} from "react-router-dom";
import Analytics from "components/layout/analytics";
import ErrorBoundary from "components/layout/error-boundary";
import Footer from "components/layout/footer";
import Navbars from "components/layout/navbars";
import Notifications from "components/layout/notifications";

export default function Router() {
  return (
    <div className="app">
      <Analytics />
      <Navbars />
      <Notifications />
      <div className="page d-flex flex-column mb-4">
        <main>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
      </div>
      <Footer />
    </div>
  );
}
